// ** Entity Imports
import { useGetCurrentUserQuery } from '@/entities/user'

// ** React Imports
import { useEffect } from 'react'

// ** Third Party Imports
import { useNavigate } from 'react-router-dom'

export const Redirect = () => {
	const navigate = useNavigate()
	const { data: currentUser, isLoading } = useGetCurrentUserQuery()

	// redirect to the appropriate page based on the user's subscription status after login
	useEffect(() => {
		if (!isLoading && currentUser) {
			if (currentUser.activeSubscription) {
				navigate('/', { replace: true })
			} else {
				navigate('/choose-plan', { replace: true })
			}
		}
	}, [currentUser, isLoading, navigate])

	return null
}
